/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiRangeHighlight = ({
  className,
  hasFocus,
  showTicks,
  lowerValue,
  upperValue,
  max,
  min,
  compressed,
  background,
  onClick
}) => {
  // Calculate the width the range based on value
  // const rangeWidth = (value - min) / (max - min);
  const leftPosition = (lowerValue - min) / (max - min);
  const rangeWidth = (upperValue - lowerValue) / (max - min);
  const rangeWidthStyle = {
    background,
    marginLeft: `${leftPosition * 100}%`,
    width: `${rangeWidth * 100}%`
  };
  const classes = classNames('euiRangeHighlight', {
    'euiRangeHighlight--hasTicks': showTicks,
    'euiRangeHighlight--compressed': compressed
  }, className);
  const progressClasses = classNames('euiRangeHighlight__progress', {
    'euiRangeHighlight__progress--hasFocus': hasFocus
  });
  return <div className={classes} onClick={onClick}>
      <div className={progressClasses} style={rangeWidthStyle} />
    </div>;
};
EuiRangeHighlight.propTypes = {
  className: PropTypes.string,
  background: PropTypes.string,
  compressed: PropTypes.bool,
  hasFocus: PropTypes.bool,
  showTicks: PropTypes.bool,
  lowerValue: PropTypes.number.isRequired,
  upperValue: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

try {
  EuiRangeHighlight.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/form/range/range_highlight.tsx',
    description: '',
    displayName: 'EuiRangeHighlight',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      background: {
        defaultValue: null,
        description: '',
        name: 'background',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      compressed: {
        defaultValue: null,
        description: '',
        name: 'compressed',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      hasFocus: {
        defaultValue: null,
        description: '',
        name: 'hasFocus',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      showTicks: {
        defaultValue: null,
        description: '',
        name: 'showTicks',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      lowerValue: {
        defaultValue: null,
        description: '',
        name: 'lowerValue',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      upperValue: {
        defaultValue: null,
        description: '',
        name: 'upperValue',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      max: {
        defaultValue: null,
        description: '',
        name: 'max',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      min: {
        defaultValue: null,
        description: '',
        name: 'min',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      onClick: {
        defaultValue: null,
        description: '',
        name: 'onClick',
        parent: {
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_highlight.tsx',
          name: 'EuiRangeHighlightProps'
        }],
        required: false,
        type: {
          name: '(e: React.MouseEvent<HTMLDivElement>) => void'
        }
      }
    },
    extendedInterfaces: ['EuiRangeHighlightProps']
  };
} catch (e) {}